import React, { FC } from 'react';
import {
    GetMoreSection,
    NavLinksSection,
    SocialLinkSection,
    SmallPrintSection
} from './section';
import { StyledHiddenHeading2, StyledList, ListItem } from './Footer.styles';
import { StyledMainFooter } from './Footer.styles';
import { Props } from './Footer.types';

import ui from './scripts/ui';

const Footer: FC<Props> = ({ hideCards, as }) => (
    <StyledMainFooter as={as} data-testid="footer">
        <StyledHiddenHeading2>Site links and resources</StyledHiddenHeading2>
        {!hideCards && <GetMoreSection />}
        <StyledList>
            <NavLinksSection />
            <ListItem>
                <SocialLinkSection />
            </ListItem>
            <ListItem>
                <SmallPrintSection />
            </ListItem>
        </StyledList>
        <script dangerouslySetInnerHTML={{ __html: `(${ui()})()` }} />
    </StyledMainFooter>
);

export { Footer };
